module.exports = __webpack_public_path__ + "static/media/receta-11.ea8976be.png";